"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#000000' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17.9998C14.4183 17.9998 18 14.418 18 9.99976C18 5.58148 14.4183 1.99976 10 1.99976C5.58172 1.99976 2 5.58148 2 9.99976C2 14.418 5.58172 17.9998 10 17.9998ZM11.3929 8.21454C11.3386 8.20665 11.2917 8.17256 11.2674 8.12337L10.1495 5.85814C10.0883 5.73427 9.91168 5.73427 9.85054 5.85814L8.73259 8.12337C8.70831 8.17256 8.66138 8.20665 8.6071 8.21454L6.10728 8.57779C5.97057 8.59765 5.91599 8.76565 6.01491 8.86207L7.8238 10.6253C7.86308 10.6636 7.881 10.7188 7.87173 10.7728L7.44471 13.2625C7.42136 13.3987 7.56426 13.5025 7.68653 13.4382L9.92244 12.2628C9.971 12.2372 10.029 12.2372 10.0776 12.2628L12.3135 13.4382C12.4357 13.5025 12.5786 13.3987 12.5553 13.2625L12.1283 10.7728C12.119 10.7188 12.1369 10.6636 12.1762 10.6253L13.9851 8.86207C14.084 8.76565 14.0294 8.59765 13.8927 8.57779L11.3929 8.21454Z",
    fill: fill
  }));
};

exports["default"] = _default;